import React from "react";
import TaxList from "./TaxList.tsx";
import TaxFilters from "./TaxFilters.tsx";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { observer } from "mobx-react-lite";
import { Link, Outlet } from "react-router-dom";

const TaxDashboard: React.FC = () => {
  return (
    <div>
      <h1>Taxes</h1>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <TaxFilters />
        <Button
          component={Link}
          to="create"
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ alignSelf: "baseline" }}
        >
          Add new
        </Button>
      </Box>
      <TaxList />
      <Outlet />
    </div>
  );
};

export default observer(TaxDashboard);
